import './angular-load';
export default 'angularLoad';



// WEBPACK FOOTER //
// ./index.js